import React, {useState, useContext} from 'react';
import {Button} from 'reactstrap';
import {resetPassword} from 'utils/api/authApi';
import {Link, useHistory} from 'react-router-dom';
import SpinnerButton from 'components/SpinnerButton';
import {ErrorContext} from 'contexts/ErrorContext';
import InputWithError from 'components/InputWithError';

const ResetPasswordPage = () => {
    let history = useHistory();
    const {handleErrors} = useContext(ErrorContext);
    const [submitting, setSubmitting] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);

    const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const handleSubmit = async() => {
        const href = window.location.href;
        const count = href.indexOf('reset');
        const route = href.slice(0, count);
        try {
            setSubmitting(true);
            setError(null);
            const params = {
                email,
                targetUrl: `${route}new_password`,
            };
            const sent = await resetPassword(params);
            if(sent) {
                setEmailSent(true);
            }
            setSubmitting(false);
        } catch(err) {
            setSubmitting(false);
            const result = emailRegExp.test(email);
            if(result) {
                setEmailSent(true);
            } else {
                handleErrors(err, setError);
            }
        }
    };


    return (
        <div className="d-flex flex-column justify-content-center align-items-center"
             style={{height: 'calc(100vh - 100px)', width: '100%'}}>
            {emailSent ?
                <div className="d-flex flex-column authorization-container">
                    <div className="text-center">
                        <h2>Check your Email</h2>
                        <p className="mb-4 mt-3 text-muted">An email containing a password reset link
                            was sent to the email you provided. Please click the link in the email and
                            follow the instructions provided.</p>
                        <Button
                            onClick={() => history.push('/signin')}
                            className="btn calltoaction-button" block
                            color="primary">
                            Return to Login
                        </Button>
                    </div>
                </div>
                :
                <div className="d-flex flex-column authorization-container">
                    <h3 className="align-self-center mb-2" style={{fontWeight: '700', fontFamily: 'Sans-serif'}}>
                        Reset Password
                    </h3>
                    <p className="align-self-center mb-3" style={{width: '350px', textAlign: 'center'}}>
                        Enter your email address and we will send you a link to reset your password
                    </p>
                    <div>
                        <InputWithError
                            placeholder="Email"
                            name="email"
                            value={email}
                            type="email"
                            onChange={setEmail}
                            errorObj={error}
                            prependIcon={<i className="fas fa-at"/>}
                            marginBottomClass="mb-3"
                            onPressEnter={handleSubmit}
                        />
                        {/*<InputGroup className="mb-3">*/}
                        {/*    <div className="input-group-prepend">*/}
                        {/*        <span style={{width: '40px'}} className="input-group-text" id="basic-addon1">*/}
                        {/*            <i className="fas fa-at"/>*/}
                        {/*        </span>*/}
                        {/*    </div>*/}
                        {/*    <Input placeholder="E-mail" value={login} onChange={(e) => handleChange(e.target.value)}/>*/}
                        {/*</InputGroup>*/}
                        <div className="d-flex flex-column justify-content-between align-self-start">
                            <SpinnerButton
                                submitting={submitting}
                                title="Send Link"
                                onClick={handleSubmit}
                                disabled={!email.length}
                            />
                            <Link
                                to="/signin"
                                className="mt-2"
                                style={{
                                    width: '130px',
                                    textDecoration: 'underline',
                                }}
                            >
                                Back to sign in
                            </Link>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default ResetPasswordPage;
